module.exports = __webpack_public_path__ + "img/rank-2.5899f9a1.png";